exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: table-row-group;\n  transform: translate3d(0, -3px, 0); }\n\n::ng-deep tog-nav-item:first-child tog-table-cell {\n  border-top-left-radius: 0px !important;\n  border-top-right-radius: 0px !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/table/table-body/table-body.component.scss
// module id = ../../../../../src/app/shared/components/table/table-body/table-body.component.scss
// module chunks = 12